<template>
  <v-app>
    <v-snackbar
      v-model="showSnack"
      :color="snackBar.type"
      :timeout="snackBar.timeout"
      bottom
    >{{snackBar.message}}</v-snackbar>

    <v-main>
      <router-view />
    </v-main>

    <v-navigation-drawer
      v-if="userToken !== ''"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items" model="1">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-item
            v-if="filteredItems(item)"
            :key="item.text"
            @click="$router.push(item.path)"
            :class="{'v-list-item--active': isActive(item.path)}"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="black" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon v-if="userToken !== ''" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">{{this.selectedDashboard.name}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-switch class="switch-center mt-6" :label="`Dark`" v-model="goDark"></v-switch> -->

      <v-btn icon>
        <v-icon v-if="isDark" @click="setDarkMode(false)">mdi-lightbulb-on-outline</v-icon>
        <v-icon v-else @click="setDarkMode(true)">mdi-lightbulb-on</v-icon>
      </v-btn>

      <v-btn icon v-if="userToken !== ''" class="mr-5">
        <router-link to="logout">
          <v-icon>mdi-logout</v-icon>
        </router-link>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn href="#" icon large target="_blank" v-on="on">
                <v-icon large>mdi-code-tags</v-icon>
              </v-btn>
            </template>
            <span>Created at Barn for Cekkazan | Justsnap</span>
          </v-tooltip>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  components: {},
  created() {
    if (localStorage && localStorage.isDark)
      this.setDarkMode(localStorage.isDark === "true");

    if (
      this.$router.currentRoute.path === "/" &&
      localStorage &&
      localStorage.previousPage
    ) {
      this.$router.push(localStorage.previousPage);
    } else {
      localStorage.previousPage = this.$router.currentRoute.name;
    }
    if ("name" in this.selectedDashboard) {
      this.$store.commit(
        "setDashboard",
        JSON.parse(localStorage.selectedDashboard)
      );
      this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
    }
    const payload = {
      userToken: this.userToken,
      dashboard: this.selectedDashboard
    };

    this.getDashboardData(payload);
  },
  mounted() {
    this.changeTitle();
  },
  data() {
    return {
      dialog: false,
      drawer: null,
      items: [
        {
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          path: "/receipts",
          hideInRoles: ["AGENT", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-view-dashboard",
          text: "Service Operation",
          path: "/serviceOp",
          hideInRoles: ["AGENT", "OPERATOR", "AGENTL1"]
        },
        {
          icon: "mdi-bullhorn",
          text: "Agent",
          path: "/agent",
          hideInRoles: ["OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-bullhorn",
          text: "L1 Agent",
          path: "/agentL1",
          hideInRoles: ["OPERATOR", "SERVICEOP", "AGENT"]
        },
        {
          icon: "mdi-text-search",
          text: "Search by Email",
          path: "/searchByEmail",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        {
          icon: "mdi-database-export",
          text: "Data Files Export",
          path: "/dataFiles",
          hideInRoles: ["OPERATOR", "SERVICEOP", "AGENT", "AGENTL1"]
        },
        {
          icon: "mdi-database-export",
          text: "Mistakes Report",
          path: "/mistakeReportsExport",
          hideInRoles: ["OPERATOR", "SERVICEOP", "AGENT", "AGENTL1"]
        },
        {
          icon: "mdi-bullhorn",
          text: "Declined Payments",
          path: "/declinedPayments",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        {
          icon: "mdi-bullhorn",
          text: "Fraud Receipts",
          path: "/fraudReceipts",
          hideInRoles: ["OPERATOR","SERVICEOP"]
        },
        {
          icon: "mdi-history",
          text: "All Receipts",
          path: "/allReceipts",
          hideInRoles: ["SERVICEOP"]
        },
        {
          icon: "mdi-hand-back-left",
          text: "Hold Receipts",
          path: "/holdReceipts",
          hideInRoles: ["AGENT", "OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-cancel",
          text: "Rejected Receipts",
          path: "/rejectedReceipts",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        {
          icon: "mdi-chart-line",
          text: "Statistics",
          path: "/statistics",
          hideInRoles: ["SERVICEOP"]
        },
        {
          icon: "mdi-cancel",
          text: "Black List",
          path: "/blackList",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        {
          icon: "mdi-clipboard-list",
          text: "Winner List",
          path: "/winnerList",
          hideInRoles: ["AGENT", "OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-export-variant",
          text: "Export Winner List",
          path: "/exportwinnerList",
          hideInRoles: ["AGENT", "OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-slot-machine",
          text: "Raffle",
          path: "/raffle",
          hideInRoles: ["AGENT", "OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-slot-machine",
          text: "DACH Raffle",
          path: "/dach-raffle"
        },
        {
          icon: "mdi-format-list-checks",
          text: "Participation Counts",
          path: "/participationCounts",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        {
          icon: "mdi-file-excel",
          text: "Export Statistics",
          path: "/exportStatistics",
          hideInRoles: ["AGENT", "OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-calculator",
          text: "Payment Corrections",
          path: "/paymentCorrection",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        // {
        // 	icon: "mdi-barcode-scan",
        // 	text: "Campaigns",
        // 	path: "/campaigns",
        // 	requireAdmin: false
        // },
        {
          icon: "mdi-cog-outline",
          text: "Settings",
          path: "/settings"
        },
        {
          icon: "mdi-cash",
          text: "BounceBacks",
          path: "/bounceBacks",
          hideInRoles: ["OPERATOR", "SERVICEOP"]
        },
        {
          icon: "mdi-clipboard-text",
          text: "Campaign Info",
          path: "/campaignInfo",
          hideInRoles: ["AGENT", "OPERATOR", "SERVICEOP", "AGENTL1"]
        },
        {
          icon: "mdi-logout",
          text: "Logout",
          path: "/logout"
        },

        // {
        // 	icon: "mdi-logout",
        // 	text: "Test",
        // 	path: "/test"
        // }
      ]
    };
  },
  methods: {
    ...mapActions([
      "snackAlert",
      "setDarkMode",
      "getDashboardData",
      "getCampaignDashboards"
    ]),
    changeTitle(pageName = '') {
      let name = this.selectedDashboard.name ? this.selectedDashboard.name : '';
      if (pageName && name) {
        name = `${name} - ${this.toCapitalize(pageName)}`
      } else if (pageName) {
        name = `${this.toCapitalize(pageName)}`
      } else {
        name = 'Dashboard'
      }
      document.title = name ? name.replace(/([a-z])([A-Z])/g, '$1 $2') : 'Dashboard';
    },
    toCapitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    isActive(path) {
      return this.$router.currentRoute.path === path;
    },
    filteredItems(sideBarItem) {
      let show = true;
      if (sideBarItem.hideInRoles) {
        sideBarItem.hideInRoles.forEach(role => {
          if (this.userRoles === role) show = false;
        });
        return show;
      } else return true;
    }
  },
  computed: {
    ...mapGetters([
      "snackBar",
      "showSnackBar",
      "userToken",
      "isAdmin",
      "isDark",
      "selectedDashboard",
      "userRoles"
    ]),
    showSnack: {
      get() {
        return this.showSnackBar;
      },
      set(val) {
        this.$store.commit("setSnackBarShow", val);
      }
    }
  },
  watch: {
    $route(to) {
      if (to.name !== 'login') {
        this.changeTitle(to.name);
      } else {
        document.title = 'Dashboard'
      }
      if (localStorage) localStorage.previousPage = to.name;
    },
    isDark(val) {
      this.$vuetify.theme.dark = val;
      localStorage.isDark = val;
    }
  }
};
</script>
<style scoped>
.switch-center {
  display: flex;
  justify-content: center;
}

.alert {
  display: flex;
  justify-self: center;
  align-self: center;
  position: absolute;
  z-index: 99999;
}
.v-application a {
  color: aliceblue;
  cursor: pointer;
  text-decoration: none;
}
.v-list-item--active {
  pointer-events: none;
}
</style>
